import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "./base/api.service";
import { UserRequestWeb3SignInDto } from "../dtos/user-request-web3-sign-in.dto";
import { UserResponseWeb3SignInDto } from "../dtos/user-response-web3-sign-in.dto";
import { UserAuthDto } from "../dtos/user-auth.dto";
import { CurrentUserDto } from "../dtos/current-user.dto";

@Injectable({
    providedIn: 'root',
})
export class UserService {

    private readonly baseUrl = 'user/';

    constructor(private apiService: ApiService) { }

    requestWeb3SignIn(model: UserRequestWeb3SignInDto): Observable<UserResponseWeb3SignInDto> {
        return this.apiService.post<UserResponseWeb3SignInDto>(this.baseUrl+'request-web3-sign-in', model);
    }

    verifyWeb3SignIn(model: UserRequestWeb3SignInDto): Observable<UserAuthDto> {
        return this.apiService.post<UserAuthDto>(this.baseUrl+'verify-web3-sign-in', model);
    }

    getCurrent(): Observable<CurrentUserDto> {
        return this.apiService.get<CurrentUserDto>(this.baseUrl + 'current');
    }
}